<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Charity",
    "pageDesc":"Supporting charitable organization and non for profit associations to serve the community better through reliable solutions.",
    "mantra":"Grow your charity |mission.",
    "sec1Items":{
      "1":{
        "title":"Non- profit websites",
        "desc":"Have an online presence and document your activities to be accessible for everyone online and increase your global credibility.",
        "url":"/solutions/web-apps"
      },
      "2":{
        "title":"CRM integration",
        "desc":"Manage your organization relations with donors and volunteers through a system that centralizes your communication and integrates a membership area into your system.",
        "url":"/solutions/crm"
      },
      "3":{
        "title":"Mobile Apps",
        "desc":"Track your orgniton activities or increase your fundraising channels with a mobile app that is customized for your nonprofit activities scope.",
        "url":"/solutions/mobile-apps"
      },
      "4":{
        "title":"Fundraising campaigns",
        "desc":"Helping you communicate your messages and drive people’s attention towards your case with creative campaigns that trigger emotions. ",
        "url":"/solutions/campaign"
      },
      "5":{
        "title":"Brand identity design",
        "desc":"From logo to your volunteers T-shirts, we handle everything to show your professional side and help you grow your charitable activities.",
        "url":"/services/branding"
      }
    },
    "sec2":"Do more good |everyday.",
    "sec2Items":{
      "1":{
        "title":"Serve community",
        "desc":"Connect to your local chapters and community and extend your global presence as well."
      },
      "2":{
        "title":"Increase volunteerism",
        "desc":"Recruit volunteers who would support your mission and automate the selection for a more organized efforts."
      },
      "3":{
        "title":"Increase funds",
        "desc":"Spread awareness about your activities and attract like minded organizations and individuals "
      }
    },
    "cta":"Do good in a <br> smarter way."
  },
  "ar": {
    "pageTitle":"الأعمال الخيرية",
    "pageDesc":"ندعم المنظمات الخيرية والجمعيات الغير هادفة للربح التي تخدم المجتمع وتحسن من حياة الأشخاص من خلال حلول موثوقة.",
    "mantra":"انشر رسالتك للعالم من |خلال الأعمال الخيرية.",
    "sec1Items":{
      "1":{
        "title":"المواقع غير الربحية",
        "desc":"أسس وجودك على الانترنت ووثق جميع الأنشطة التي تقوم بها لتكون في متناول الجميع وزود من مصداقية أهدافك ورسالتك.",
        "url":"/solutions/web-apps"
      },
      "2":{
        "title":"تكامل إدارة علاقات العملاء",
        "desc":"قم بإدارة علاقاتك مع الجهات المانحة والمتطوعين  بكل سهولة من خلال نظام يقوم بتنظيم اتصالاتك ويدمج العضويات في نظامك.",
        "url":"/solutions/crm"
      },
      "3":{
        "title":"تطبيقات الجوال",
        "desc":"تتبع أنشطة المنظمة الخاصة بك أو وسع من القنوات التي تساعدك على جمع الأموال من خلال تطبيق الجوال مخصص من أجل أنشطتك الربحية.",
        "url":"/solutions/mobile-apps"
      },
      "4":{
        "title":"حملات جمع التبرعات",
        "desc":"نساعدك على توصيل رسالتك وجذب انتباه الناس تجاه قضيتك من خلال الحملات الإبداعية التي تحرك المشاعر.",
        "url":"/solutions/campaign"
      },
      "5":{
        "title":"تصميم هوية العلامة التجارية",
        "desc":"من الشعار حتى تيشيرتات المتطوعين، نصمم كل شيء من أجل توضيح جانبك المهني ومساعدتك على تنمية أنشطتك الخيرية.",
        "url":"/services/branding"
      }
    },
    "sec2":"ابذل المزيد من |الخير كل يوم.",
    "sec2Items":{
      "1":{
        "title":"خدمة المجتمع",
        "desc":"تواصل مع مجتمعك وأعضاء مجتمعك المحلي واعمل على توسيع أنشطتك عالميًا."
      },
      "2":{
        "title":"زود المتطوعين",
        "desc":"اجذب المزيد من المتطوعين لدعم مهمتك ونشر رسالتك وقم بأتمتة الاختيارات من أجل تنظيم جهودك."
      },
      "3":{
        "title":"زيادة الأموال",
        "desc":"انشر الوعى حول الأنشطة الخاصة بك واجذب المزيد من الأفراد المهتمين بالعمل التطوعي والأعمال الخيرية."
      }
    },
    "cta":"حفز الناس على فعل <br> الخير والتطوع"
  }
}
</i18n>
